import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-09eb75ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "head-card cm-ui-mb15 cm-ui-mt15" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "subtitle" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "cm-ui-mb15" }
const _hoisted_6 = { class: "info-txt" }
const _hoisted_7 = { class: "info-content" }
const _hoisted_8 = { class: "info-txt" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  id: "ed-pc-speed-ck",
  type: "checkbox",
  checked: ""
}, null, -1))
const _hoisted_10 = {
  for: "ed-pc-speed-ck",
  class: "card-header"
}
const _hoisted_11 = { class: "left-block" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pc-card-icon-speed" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-up arrow-icon" }, null, -1))
const _hoisted_14 = { class: "card-content" }
const _hoisted_15 = { class: "item" }
const _hoisted_16 = { class: "item" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  id: "ed-system-err-ck",
  type: "checkbox",
  checked: ""
}, null, -1))
const _hoisted_19 = {
  for: "ed-system-err-ck",
  class: "card-header"
}
const _hoisted_20 = { class: "left-block" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pc-card-icon-system" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-up arrow-icon" }, null, -1))
const _hoisted_23 = { class: "card-content" }
const _hoisted_24 = { class: "item" }
const _hoisted_25 = { class: "item" }
const _hoisted_26 = { class: "item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  id: "ed-loaris-trojan-ck",
  type: "checkbox",
  checked: ""
}, null, -1))
const _hoisted_28 = {
  for: "ed-loaris-trojan-ck",
  class: "card-header"
}
const _hoisted_29 = { class: "left-block" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pc-card-icon-loaris" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-up arrow-icon" }, null, -1))
const _hoisted_32 = { class: "card-content" }
const _hoisted_33 = { class: "item" }
const _hoisted_34 = { class: "item" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  id: "ed-pc-rubbish-ck",
  type: "checkbox",
  checked: ""
}, null, -1))
const _hoisted_36 = {
  for: "ed-pc-rubbish-ck",
  class: "card-header"
}
const _hoisted_37 = { class: "left-block" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pc-card-icon-rubbish" }, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right-block" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-up arrow-icon" })
], -1))
const _hoisted_40 = { class: "card-content" }
const _hoisted_41 = { class: "item" }
const _hoisted_42 = { class: "item" }
const _hoisted_43 = { class: "item" }
const _hoisted_44 = { class: "item" }
const _hoisted_45 = { class: "item" }
const _hoisted_46 = { class: "item" }
const _hoisted_47 = { class: "item" }
const _hoisted_48 = { class: "item" }
const _hoisted_49 = { class: "item" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  id: "ed-pc-protected-ck",
  type: "checkbox",
  checked: ""
}, null, -1))
const _hoisted_51 = {
  for: "ed-pc-protected-ck",
  class: "card-header"
}
const _hoisted_52 = { class: "left-block" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pc-card-icon-protect" }, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-up arrow-icon" }, null, -1))
const _hoisted_55 = { class: "card-content" }
const _hoisted_56 = { class: "item" }
const _hoisted_57 = { class: "item" }
const _hoisted_58 = { class: "item" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  id: "ed-pc-software-ck",
  type: "checkbox",
  checked: ""
}, null, -1))
const _hoisted_60 = {
  for: "ed-pc-software-ck",
  class: "card-header"
}
const _hoisted_61 = { class: "left-block" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pc-card-icon-ad" }, null, -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-up arrow-icon" }, null, -1))
const _hoisted_64 = { class: "card-content" }
const _hoisted_65 = { class: "item" }
const _hoisted_66 = {
  key: 0,
  class: "fixed-btn-cntr"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "exam-drawer-wrapper",
    style: _normalizeStyle({ 'margin-bottom': _ctx.drawerOptions.baseInfo.score === 100 ? '10px' : '100px'})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["card cm-ui-pd5", _ctx.calcScoreColor(_ctx.drawerOptions.baseInfo.score)])
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.drawerOptions.baseInfo.score), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('noticeManage.examScore')), 1)
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.registerUserLabel')), 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.drawerOptions.baseInfo.user_mark), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.groupLabel')), 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.drawerOptions.baseInfo.group_name), 1)
        ])
      ])
    ]),
    _hoisted_9,
    _createVNode(_component_el_card, { class: "collapse-card cm-ui-mt15" }, {
      header: _withCtx(() => [
        _createElementVNode("label", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('noticeManage.pcSpeed')), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["right-block", _ctx.drawerOptions.exam_detail.speed.count ? 'color-red' : ''])
          }, [
            _createTextVNode(_toDisplayString(_ctx.drawerOptions.exam_detail.speed.count) + _toDisplayString(_ctx.$t('noticeManage.itemsProblem')), 1),
            _hoisted_13
          ], 2)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.bootSpeed')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.speed.start ? 'result-red': 'item-result')
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.speed.start ? _ctx.drawerOptions.exam_detail.speed.start + _ctx.$t('noticeManage.itemsProblem') : _ctx.$t('noticeManage.optimal')), 3)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.networkSpeed')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.speed.network ? 'result-red': 'item-result')
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.speed.network ? _ctx.drawerOptions.exam_detail.speed.network + _ctx.$t('noticeManage.itemsProblem') : _ctx.$t('noticeManage.optimal')), 3)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.systemSpeed')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.speed.system ? 'result-red': 'item-result')
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.speed.system ? _ctx.drawerOptions.exam_detail.speed.system + _ctx.$t('noticeManage.itemsProblem') : _ctx.$t('noticeManage.optimal')), 3)
          ])
        ])
      ]),
      _: 1
    }),
    _hoisted_18,
    _createVNode(_component_el_card, { class: "collapse-card cm-ui-mt15" }, {
      header: _withCtx(() => [
        _createElementVNode("label", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('noticeManage.systemAbnormal')), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["right-block", _ctx.drawerOptions.exam_detail.system.count ? 'color-red' : ''])
          }, [
            _createTextVNode(_toDisplayString(_ctx.drawerOptions.exam_detail.system.count) + _toDisplayString(_ctx.$t('noticeManage.itemsProblem')), 1),
            _hoisted_22
          ], 2)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.networkSetting')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.system.network ? 'result-red': 'item-result')
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.system.network ? _ctx.drawerOptions.exam_detail.system.network + _ctx.$t('noticeManage.itemsProblem') : _ctx.$t('noticeManage.safe')), 3)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.browserSecurity')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.system.browser ? 'result-red': 'item-result'),
              style: {"margin-left":"24px"}
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.system.browser ? _ctx.drawerOptions.exam_detail.system.browser + _ctx.$t('noticeManage.itemsProblem') : _ctx.$t('noticeManage.safe')), 3)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.systemProblem')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.system.problem ? 'result-red': 'item-result')
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.system.problem ? _ctx.drawerOptions.exam_detail.system.problem + _ctx.$t('noticeManage.itemsProblem') : _ctx.$t('noticeManage.safe')), 3)
          ])
        ])
      ]),
      _: 1
    }),
    _hoisted_27,
    _createVNode(_component_el_card, { class: "collapse-card cm-ui-mt15" }, {
      header: _withCtx(() => [
        _createElementVNode("label", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('noticeManage.virusTrojan')), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["right-block", _ctx.drawerOptions.exam_detail.virus.count ? 'color-red' : ''])
          }, [
            _createTextVNode(_toDisplayString(_ctx.drawerOptions.exam_detail.virus.count) + _toDisplayString(_ctx.$t('noticeManage.itemsProblem')), 1),
            _hoisted_31
          ], 2)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.systemSecurity')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.virus.system ? 'result-red': 'item-result')
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.virus.system ? _ctx.drawerOptions.exam_detail.virus.system + _ctx.$t('noticeManage.itemsProblem') : _ctx.$t('noticeManage.safe')), 3)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.mobileDevices')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.virus.mobile_devices ? 'result-red': 'item-result')
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.virus.mobile_devices ? _ctx.drawerOptions.exam_detail.virus.mobile_devices + _ctx.$t('noticeManage.itemsProblem') : _ctx.$t('noticeManage.safe')), 3)
          ])
        ])
      ]),
      _: 1
    }),
    _hoisted_35,
    _createVNode(_component_el_card, { class: "collapse-card cm-ui-mt15" }, {
      header: _withCtx(() => [
        _createElementVNode("label", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('noticeManage.pcGarbage')), 1)
          ]),
          _hoisted_39
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.gameGarbage')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.garbage.game ? 'result-red': 'item-result')
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.garbage.game ? _ctx.calcFileSize(_ctx.drawerOptions.exam_detail.garbage.game) : _ctx.$t('noticeManage.veryClean')), 3)
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.registerGarbage')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.garbage.register ? 'result-red': 'item-result'),
              style: {"margin-left":"24px"}
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.garbage.register ? _ctx.calcFileSize(_ctx.drawerOptions.exam_detail.garbage.register) : _ctx.$t('noticeManage.veryClean')), 3)
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.uselessSoft')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.garbage.useless ? 'result-red': 'item-result')
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.garbage.useless ? _ctx.calcFileSize(_ctx.drawerOptions.exam_detail.garbage.useless) : _ctx.$t('noticeManage.veryClean')), 3)
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.mediaGarbage')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.garbage.movie ? 'result-red': 'item-result')
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.garbage.movie ? _ctx.calcFileSize(_ctx.drawerOptions.exam_detail.garbage.movie) : _ctx.$t('noticeManage.veryClean')), 3)
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.networkGarbage')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.garbage.network ? 'result-red': 'item-result')
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.garbage.network ? _ctx.calcFileSize(_ctx.drawerOptions.exam_detail.garbage.network) : _ctx.$t('noticeManage.veryClean')), 3)
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.systemGarbage')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.garbage.system ? 'result-red': 'item-result')
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.garbage.system ? _ctx.calcFileSize(_ctx.drawerOptions.exam_detail.garbage.system) : _ctx.$t('noticeManage.veryClean')), 3)
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.talkGarbage')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.garbage.talk ? 'result-red': 'item-result')
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.garbage.talk ? _ctx.calcFileSize(_ctx.drawerOptions.exam_detail.garbage.talk) : _ctx.$t('noticeManage.veryClean')), 3)
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.residualGarbage')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.garbage.uninstall ? 'result-red': 'item-result')
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.garbage.uninstall ? _ctx.calcFileSize(_ctx.drawerOptions.exam_detail.garbage.uninstall) : _ctx.$t('noticeManage.veryClean')), 3)
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.otherGarbage')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.garbage.other ? 'result-red': 'item-result')
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.garbage.other ? _ctx.calcFileSize(_ctx.drawerOptions.exam_detail.garbage.other) : _ctx.$t('noticeManage.veryClean')), 3)
          ])
        ])
      ]),
      _: 1
    }),
    _hoisted_50,
    _createVNode(_component_el_card, { class: "collapse-card cm-ui-mt15" }, {
      header: _withCtx(() => [
        _createElementVNode("label", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _hoisted_53,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('noticeManage.pcComputerProtection')), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["right-block", _ctx.drawerOptions.exam_detail.guard.count ? 'color-red' : ''])
          }, [
            _createTextVNode(_toDisplayString(_ctx.drawerOptions.exam_detail.guard.count) + _toDisplayString(_ctx.$t('noticeManage.itemsProblem')), 1),
            _hoisted_54
          ], 2)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _createTextVNode(_toDisplayString(_ctx.$t('examinationStatus.systemProtect')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.guard.system ? 'result-red': 'item-result')
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.guard.system ? _ctx.drawerOptions.exam_detail.guard.system + _ctx.$t('noticeManage.itemsProblem') : _ctx.$t('noticeManage.safe')), 3)
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createTextVNode(_toDisplayString(_ctx.$t('examinationStatus.shopProtect')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.guard.shop ? 'result-red': 'item-result')
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.guard.shop ? _ctx.drawerOptions.exam_detail.guard.shop + _ctx.$t('noticeManage.itemsProblem') : _ctx.$t('noticeManage.safe')), 3)
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createTextVNode(_toDisplayString(_ctx.$t('examinationStatus.homepageProtect')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.guard.homepage ? 'result-red': 'item-result')
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.guard.homepage ? _ctx.drawerOptions.exam_detail.guard.homepage + _ctx.$t('noticeManage.itemsProblem') : _ctx.$t('noticeManage.safe')), 3)
          ])
        ])
      ]),
      _: 1
    }),
    _hoisted_59,
    _createVNode(_component_el_card, { class: "collapse-card cm-ui-mt15" }, {
      header: _withCtx(() => [
        _createElementVNode("label", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _hoisted_62,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('examinationStatus.softClean')), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["right-block", _ctx.drawerOptions.exam_detail.soft.promotion ? 'color-red' : ''])
          }, [
            _createTextVNode(_toDisplayString(_ctx.drawerOptions.exam_detail.soft.promotion) + _toDisplayString(_ctx.$t('noticeManage.itemsProblem')), 1),
            _hoisted_63
          ], 2)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createTextVNode(_toDisplayString(_ctx.$t('noticeManage.softPromotion')) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.drawerOptions.exam_detail.soft.promotion ? 'result-red': 'item-result')
            }, _toDisplayString(_ctx.drawerOptions.exam_detail.soft.promotion ? _ctx.drawerOptions.exam_detail.soft.promotion + _ctx.$t('noticeManage.itemsProblem') : _ctx.$t('noticeManage.optimal')), 3)
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.drawerOptions.baseInfo.score !== 100)
      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
          _createVNode(_component_el_button, {
            size: "small",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.repairSingleTerminal())),
            class: "fix-btn",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('examinationTable.repairNow')), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 4))
}